import FormPageTemplate from './FormPageTemplate'

const ConstructionNewProjectPage = () => (
    <FormPageTemplate
        titleKey="admin.monday.construction_new_project"
        subtitleKey="admin.monday.construction_form_desc"
        defaultFormType="construction_new_project"
        returnPath="/construction"
    />
)

export default ConstructionNewProjectPage
